<template>
  <!-- 全部园区列表 -->
  <div class="investment_info">
    <div class="m">
      <div class="classify_box">
        <!--区域-->
        <type_filter :filterObj="filterObj" filedType="code" @selctedType="selctedType"></type_filter>
        <!--领域-->
        <type_filter :filterObj="filterObj2" filedType="id" @selctedType="selctedType"></type_filter>
        <!--类型-->
        <type_filter :filterObj="filterObj3" @selctedType="selctedType"></type_filter>
        <!--孵化器级别-->
        <type_filter :filterObj="filterObj5" @selctedType="selctedType" :filedType="'id'"></type_filter>
      </div>

      <div class="normal_box">
        <!--常规筛选-->
        <type_filter :filterObj="filterObj4" @selctedType="selctedType"></type_filter>
      </div>
      <!-- 园区列表 -->
      <park_list :list="list"></park_list>
      <!-- 分页 -->
    <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
    </div>
  </div>
</template>

<script>
import myPage from "@/components/myPage/myPage";
import park_list from "@/components/park/park_list.vue";
import type_filter from "@/components/type_filter/type_filter.vue"; //选择code
export default {
  components: {
    myPage,
    park_list,
    type_filter
  },
  data() {
    return {
      searchObj: {
        province: '',
        city: "", //地区
        fields: "", //领域
        type: "", //类型
        sort: "SortDefault" //常规
      },
      layerpageinfo: {
        pageSize: 9,
        pageNo: 0,
        total: 0
      },
      list: [], //园区列表
      filterObj: {
        //地区筛选对象
        name: "地区",
        code: "city",
        list: []
      },
      filterObj2: {
        //行业筛选对象
        name: "领域",
        code: "fields",
        list: []
      },
      filterObj3: {
        //类型筛选对象
        name: "类型",
        code: "type",
        list: []
      },
      filterObj4: {
        //常规筛选对象
        name: "",
        code: "sort",
        list:  [
          {
            code: "SortDefault",
            name: "默认",
          },
          {
            code: "SortPriceASC",
            name: "价格升序",
          },
          {
            code: "SortPriceDESC",
            name: "价格降序",
          },
          {
            code: "SortTimeASC",
            name: "时间升序",
          },
          {
            code: "SortTimeDESC",
            name: "时间降序",
          },
          {
            code: "SortPopularity",
            name: "人气升序",
          },
          {
            code: "SortPopularityDESC",
            name: "人气降序",
          },
        ]
      },
      filterObj5: {
        //孵化器级别
        name: "孵化器级别",
        code: "levels",
        list: []
      }
    };
  },
  mounted() {
    this.initParams();
    this.getParam();
  },
  methods: {
      //条件查询孵化器园区
    getParam() {
      let params = Object.assign({}, this.searchObj, this.layerpageinfo);
      this.api.getIncubators(params).then(res => {
        if (res.error.err_code !== 0) return;
        let list = res.obj.list || [];
        list.forEach((item, idx) => {
          list[idx]["key_word"] = item.key_word.trim().split("|");
        });
        this.list = list;
        this.layerpageinfo.total = res.obj.totalSize;
      });
    },
    //获取所有类型的字典
    initParams() {
      this.getDictionaries("GuangdongCity").then(res => {
        this.filterObj.list = res;
      });
      this.getDictionaries("FieldOtherIndustries").then(res => {
        this.filterObj2.list = res;
      });
      this.getDictionaries("IncubatorType").then(res => {
        this.filterObj3.list = res;
      });
      // this.getDictionaries("Sort").then(res => {
      //   this.filterObj4.list = res;
      // });
      this.getDictionaries("IncubatorLevel").then(res => {
        this.filterObj5.list = res;
      });
    },
    /**获取对应类型字典封装
     * @params type 字典类型
     * */
    getDictionaries(type) {
      let obj = {
        typeCode: type,
        pageNo: 0,
        pageSize: 999
      };
      return new Promise(resolve => {
        this.api.getDictionaries(obj).then(res => {
          if (res.error.err_code !== 0) return;
          let list = res.obj.list;
          list = list.length ? list : null;
          resolve(list);
        });
      });
    },
    /*选择筛选条件*/
    selctedType(obj) {
      console.log(obj);
      if (obj.filedType === "code") {
        this.searchObj[obj.code] = obj.list.code;
      } else {
        this.searchObj[obj.code] = obj.list.id;
      }
      if(obj.code === 'city'){
        if(!obj.list.code){
          this.searchObj.province = '';
        }else{
          this.searchObj.province = 'GuangdongCity'
        }
      }
      this.layerpageinfo.pageNo = 0;
      this.getParam();
    },
    // 页数切换
    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
      this.getParam();
    }
  }
};
</script>

<style lang="scss">
.investment_info {
  padding-top: 18px;
  background: #fff;
  .m {
    height: 100%;
    .classify_box {
      width: 100%;
      background: #f8f8f8;
      border: 1px solid #ebeef1;
      padding: 10px 20px;
      margin-bottom: 20px;
      border-radius: 2px;
      box-sizing: border-box;
      .classify_inner_box:last-child {
        border: none;
      }
    }
    .normal_box {
       background: #f8f8f8;
      padding: 0 20px;
      margin-bottom: 20px;
    }
    
    .page_box {
      padding: 24px 0 43px;
    }
  }
}
</style>
